import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Tooltip } from 'antd';
import {
  PrimaryButton,
  Text,
  UnderlineLink,
  NoResult,
  SearchTableLabel,
} from './style';
import CharitySearch from '../../../../../../CommonComponents/CharitySearch/CharitySearch';
import Contents, {
  ContentProvider,
  ContentMessage,
  Types,
} from '../../../../../../CommonComponents/ContentMessages';
import MultipleCharityPopup from '../../../../../../CommonComponents/CharitySearch/Component/MultipleCharity/MultipleCharity';
import {
  GrantSectionHeading,
  GrantGreyBackgroundSection,
  GrantSectionSubHeading,
  CharitySectionDivider,
  ScrollUpSection,
} from '../../styles';
import {
  grantRemoveCharity,
  grantFetchSavedCharity,
  grantShowGeminiFilter,
  grantSearchGemini,
  grantPostSavedCharity,
  addCharity,
  grantPostSavedGemini,
  cancelSaveCharity,
  fetchPendingGrant,
} from '../../actions';
import GrantSearchTable from '../SearchTable/SearchTable';
import { FixedWidth } from '../../../../../../CommonComponents/commonStyles';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import { getPrimaryAccount } from '../../../../../../utils/sessionUtil';
import {
  selectCharity,
  resetSavedCharityLoadingFlag,
} from '../../../RecommendGrant/actions';
import { addressFormat } from '../../../RecommendGrant/utils';
import GrantPopup from '../../../RecommendGrant/Component/GrantPopup/GrantPopup';
import RenderCard from '../../../RecommendGrant/Component/RenderCard/RenderCard';
import { CustomTable } from '../../../RecommendGrant/Component/CharitySelect/style';
import pendingCharityColumns from '../../../RecommendGrant/Component/CharitySelect/pendingCharityColumns';
import { LinkToSamll } from '../../../RecommendGrant/style';
import {
  replaceAnchorWithLink,
  charityEligibilityChecker,
  recordError,
} from '../../../../../../utils/commonUtil';
import DrupalPopup from '../../../RecommendGrant/Component/Popup/DrupalPopup';
import PropTypes from 'prop-types';
import { charitySelectStates } from './selectors';

export class CharitySelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPendingCharity: false,
      selectedCharity: {},
      showGeminiFilter: false,
      frozen: false,
      multipleCharities: [],
      eligible: true,
      partialEligibility: false,
    };
    this.multipleCharitySaveHandler = this.multipleCharitySaveHandler.bind(
      this
    );
  }

  componentDidMount() {
    const { accountId } = this.props;
    this.getSavedCharity(accountId);
    if (getPrimaryAccount().freezes && getPrimaryAccount().freezes.length > 0) {
      this.setState({
        frozen: true,
      });
    }
  }
  componentWillUnmount() {
    this.props.resetSavedCharityLoadingFlag();
  }

  getSavedCharity = () => {
    this.props.fetchSavedCharity({
      method: 'GET',
      url: `/donor-portal/api/granteeOrg/${
        getPrimaryAccount().userId
      }/getAllCharityByAccountId`,
      page: 'grantsDashboard',
    });
  };

  getPendingGrant = (accountId, charityId) => {
    this.props.fetchPendingGrant({
      method: 'GET',
      url: `/donor-portal/api/grant/${accountId}/findGrantsByAccountIdandCharityIdandGrantStatus?charityId=${charityId}&grantStatus=pending`,
      page: 'grantsDashboard',
    });
  };

  // Handler for select of search results
  searchSelectHandler = (record, formatFn, gemini) => {
    if (record.isPending) {
      this.getPendingGrant(getPrimaryAccount().userId, record.charityId);
      this.setState({
        showPendingCharity: true,
        selectedCharity: { ...formatFn(record) },
      });
    } else if (record.isSelected) {
      this.selectCharity(formatFn(record));
    } else if (gemini) {
      this.saveGeminiCharity(record, () =>
        this.selectCharity(formatFn(record))
      );
    } else {
      this.saveCharity(record, this.multipleCharitySaveHandler);
    }
  };

  saveCharity = (record, successFn) => {
    const { accountId } = this.props;
    let recordToSave = {
      ein: record.ein,
      legalName: record.organization_name,
      addressLine1: record.address_line_1,
      addressLine2: record.address_line_2,
      addressLine3: '',
      state: record.state,
      city: record.city,
      country: 'US',
      zip: record.zip,
      charityContactFirstName: record.contact_name,
      charityContactLastName: '',
      email: record.contact_email,
      phoneNumber: record.contact_phone,
    };
    this.setState({
      saveCharityData: {
        userId: getPrimaryAccount().userId,
        charityData: recordToSave,
      },
      guideStarSelectedCharity: record,
    });
    const eligibility = charityEligibilityChecker({
      pub78: record.properties.pub78_verified,
      bmfStatus: record.properties.bmf_status,
      subSection: record.subsection_code,
      foundationCode: record.foundation_code,
    });
    if (eligibility.mandatory && eligibility.partial) {
      this.props.saveCharity(
        {
          userId: getPrimaryAccount().userId,
          charityData: recordToSave,
        },
        (response) => successFn(response, record)
      );
    } else if (eligibility.mandatory && !eligibility.partial) {
      this.setState({ partialEligibility: true });
    } else {
      this.setState({ eligible: false });
    }
  };

  saveInEligibleCharities = () => {
    if (this.state.partialEligibility === true) {
      this.setState({ partialEligibility: false });
    } else {
      this.setState({ eligible: true });
    }
    this.props.saveCharity(this.state.saveCharityData, (response) =>
      this.multipleCharitySaveHandler(
        response,
        this.state.guideStarSelectedCharity
      )
    );
  };

  saveGeminiCharity = (data, successFn) => {
    this.props.postSavedGemini(
      {
        userId: getPrimaryAccount().userId,
        charityData: {
          granteeOrgId: data.granteeOrgId,
          alias: data.legalName,
        },
      },
      successFn
    );
  };

  multipleCharitySaveHandler = (savedRecord, reqRecord) => {
    if (savedRecord.isExisting) {
      if (savedRecord.granteeOrgs && savedRecord.granteeOrgs.length === 1) {
        // add charity directly and proceed
        this.saveSelectedCharity(savedRecord.granteeOrgs[0]);
      } else if (
        savedRecord.granteeOrgs &&
        savedRecord.granteeOrgs.length > 1
      ) {
        // show multiple charity popup
        // if user tries to save multiple with ein conflict, keep first cancel rest
        if (!Object.keys(this.state.selectedCharity).length) {
          this.setState({
            multipleCharities: savedRecord.granteeOrgs,
            selectedCharity: { ...reqRecord },
          });
        } else {
          this.props.cancelSaveCharity(reqRecord);
        }
      }
    } else {
      this.selectCharity(this.formatCharity(savedRecord));
    }
  };

  saveSelectedCharity = (charity) => {
    this.addSelectedCharity(charity, () =>
      this.selectCharity(this.formatSuggestedCharity(charity))
    );
    this.setState({
      multipleCharities: [],
    });
  };

  addSelectedCharity = (data, successFn) => {
    this.props.addCharity(
      {
        userId: getPrimaryAccount().userId,
        charityData: {
          granteeOrgId: data.granteeOrgId,
          alias: data.legalName,
        },
      },
      data,
      successFn
    );
  };

  selectCharity = (record) => {
    const charityRefLink = this.props.location.pathname;
    this.props.selectCharity(record, charityRefLink);
    // redirect to recommend grant step1a
    this.props.history.push('/grants/recommend/charity-purpose');
  };

  onCancelMultipleCharity = () => {
    this.props.cancelSaveCharity(this.state.selectedCharity);
    this.setState({
      multipleCharities: [],
      selectedCharity: {},
    });
  };

  onCancelPendingCharity = () => {
    this.setState({
      showPendingCharity: false,
      selectedCharity: {},
    });
  };

  makeGrant = () => {
    const { selectedCharity } = this.state;
    this.selectCharity(selectedCharity);
  };

  // Different formatting needed as different structures from backend api
  formatCharity = (charity) => ({
    ein: charity.ein,
    name: charity.charityName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.charityId,
    interestArea: charity.interestArea,
  });

  formatSearchResult = (charity) => ({
    ein: charity.ein,
    name: charity.organization_name,
    address: {
      addressLine1: charity.address_line_1,
      addressLine2: charity.address_line_2,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.charityId,
    interestArea: charity.ntee_code,
  });

  formatSuggestedCharity = (charity) => ({
    ein: charity.ein,
    name: charity.legalName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.granteeOrgId,
    interestArea: charity.interestArea,
  });

  formatGeminiResult = (charity) => ({
    ein: charity.ein,
    name: charity.legalName,
    address: {
      addressLine1: charity.addressLine1,
      addressLine2: charity.addressLine2,
      addressLine3: charity.addressLine3,
      city: charity.city,
      state: charity.state,
      zipCode: charity.zip,
    },
    id: charity.granteeOrgId,
    interestArea: charity.interestArea,
  });

  // charity id here is the alias id
  removeCharity = (charityId) => {
    this.props.removeCharity(
      {
        method: 'POST',
        url: `/donor-portal/api/grant/${
          getPrimaryAccount().userId
        }/removeCharity?granteeOrgAliasId=${charityId}`,
        page: 'grantsDashboard',
        charityId: charityId,
        searchType: this.state.showGeminiFilter ? 'gemini' : 'guidestar',
      },
      () => {
        this.getSavedCharity(this.props.accountId);
      }
    );
  };

  viewGrants = (id, type) => {
    if (type === 'single') {
      this.props.history.push(`/grants/activity/view?grantId=${id}`);
    } else if (type === 'agreement') {
      this.props.history.push(
        `/grants/grants-agreement/view?grantAgreementId=${id}`
      );
    } else {
      this.props.history.push(`/grants/activity/view?scheduleId=${id}`);
    }
  };

  grantActivityClickHandler = () => {
    this.props.history.push('/grants/activity');
  };

  renderGeminiFilter = () => {
    try {
      this.props.searchGemini({
        method: 'GET',
        url: '/search_gemini',
        page: 'recommendGrant',
        isExternal: true,
      });
      this.setState(
        {
          showGeminiFilter: true,
        },
        () => this.props.showGeminiFilter(this.state.showGeminiFilter)
      );
    } catch (error) {
      recordError(error);
    }
  };

  renderGuidestarFilter = () => {
    try {
      this.setState(
        {
          showGeminiFilter: false,
        },
        () => this.props.showGeminiFilter(this.state.showGeminiFilter)
      );
    } catch (error) {
      recordError(error);
    }
  };

  suggestACharity = () => {
    try {
      this.props.history.push({
        pathname: '/suggest-a-charity',
      });
    } catch (error) {
      recordError(error);
    }
  };

  suggestCharityHandler = () => {
    return (
      <div>
        <Text> No matching results found on Guidestar Database. </Text>
        <PrimaryButton id='btnSuggestacharity' onClick={this.suggestACharity}>
          Suggest a charity
        </PrimaryButton>
      </div>
    );
  };

  renderSearchCharityTable = () => {
    return (
      <>
        {this.props.searchCharity.length === 0 ? (
          <SearchTableLabel className='mt-50'>
            Displaying {this.props.searchCharity.length} of{' '}
            {this.props.searchCharity.length} search results{' '}
            {this.props.grantSearchTerm
              ? 'for' + ' ' + this.props.grantSearchTerm
              : null}
          </SearchTableLabel>
        ) : (
          <SearchTableLabel className='mt-50'>
            Displaying {this.props.searchCharity.length} of{' '}
            {this.props.guidestarSearchCount} search results{' '}
            {this.props.grantSearchTerm
              ? 'for' + ' ' + this.props.grantSearchTerm
              : null}
          </SearchTableLabel>
        )}
        <Text>
          Can't find your charity?&nbsp;Search&nbsp;
          <UnderlineLink
            id='anrVanguardCharitable'
            onClick={this.renderGeminiFilter}
          >
            Vanguard Charitable
          </UnderlineLink>{' '}
          or&nbsp;
          {this.state.frozen ? (
            <Tooltip
              placement='top'
              title='This account is frozen. Contact us at 888-383-4483.'
            >
              <UnderlineLink id='anrSuggestacharity1'>
                Suggest a charity
              </UnderlineLink>
            </Tooltip>
          ) : (
            <UnderlineLink
              id='anrSuggestacharity2'
              onClick={this.suggestACharity.bind(this)}
            >
              Suggest a charity
            </UnderlineLink>
          )}
        </Text>
        {this.props.searchCharity.length > 0 && !this.props.serverDown ? (
          <GrantSearchTable
            columnData={this.props.searchCharity}
            showGeminiFilter={this.state.showGeminiFilter}
            guidestarSearchCount={this.props.guidestarSearchCount}
            pendingCharityHandler={(record) =>
              this.searchSelectHandler(record, this.formatSearchResult)
            }
            removeSavedCharity={this.removeCharity}
            getSavedCharity={this.getSavedCharity}
            addCharity={this.addSelectedCharity}
            saveCharity={this.saveCharity}
            saveGeminiCharity={this.saveGeminiCharity}
            activityBlocked={this.props.activityBlocked}
          />
        ) : this.props.searchCharity.length === 0 && this.props.serverDown ? (
          <NoResult>The system is temporarily unavailable</NoResult>
        ) : (
          <NoResult>Charity not found. </NoResult>
        )} 
      </>
    );
  };

  renderSearchGeminiTable = () => {
    if (this.props.searchGeminiStringResponse) {
      return (
        <>
          <NoResult>
            The search results have exceeded the maximum limit of 500 records.
            Please refine your search criteria and try again.
          </NoResult>
          <CharitySectionDivider />
          <Text>
            Can't find your charity? &nbsp;Search&nbsp;
            <UnderlineLink
              id='anrGuideStar1'
              onClick={this.renderGuidestarFilter}
            >
              GuideStar
            </UnderlineLink>{' '}
            or&nbsp;
            {this.state.frozen ? (
              <Tooltip
                placement='top'
                title='This account is frozen. Contact us at 888-383-4483.'
              >
                <UnderlineLink id='anrSuggestacharity3'>
                  Suggest a charity
                </UnderlineLink>
              </Tooltip>
            ) : (
              <UnderlineLink
                id='anrSuggestacharity4'
                onClick={this.suggestACharity.bind(this)}
              >
                Suggest a charity
              </UnderlineLink>
            )}
          </Text>
        </>
      );
    }
    return (
      <>
        <SearchTableLabel>
          Displaying {this.props.searchGeminiData.length} of{' '}
          {this.props.searchGeminiData.length} search results{' '}
          {this.props.grantGeminiSearchTerm
            ? 'for' + ' ' + this.props.grantGeminiSearchTerm
            : null}
        </SearchTableLabel>
        <Text>
          Can't find your charity? &nbsp;Search&nbsp;
          <UnderlineLink
            id='anrGuideStar2'
            onClick={this.renderGuidestarFilter}
          >
            GuideStar
          </UnderlineLink>{' '}
          or&nbsp;
          {this.state.frozen ? (
            <Tooltip
              placement='top'
              title='This account is frozen. Contact us at 888-383-4483.'
            >
              <UnderlineLink id='anrSuggestacharity5'>
                Suggest a charity
              </UnderlineLink>
            </Tooltip>
          ) : (
            <UnderlineLink
              id='anrSuggestacharity6'
              onClick={this.suggestACharity.bind(this)}
            >
              Suggest a charity
            </UnderlineLink>
          )}
        </Text>

        {this.props.searchGeminiData.length > 0 ? (
          <GrantSearchTable
            columnData={this.props.searchGeminiData}
            showGeminiFilter={this.state.showGeminiFilter}
            pendingCharityHandler={(record) =>
              this.searchSelectHandler(record, this.formatGeminiResult, true)
            }
            removeSavedCharity={this.removeCharity}
            getSavedCharity={this.getSavedCharity}
            addCharity={this.addSelectedCharity}
            saveCharity={this.saveCharity}
            saveGeminiCharity={this.saveGeminiCharity}
            activityBlocked={this.props.activityBlocked}
          />
        ) : (
          <NoResult>Charity not found.</NoResult>
        )}
      </>
    );
  };

  renderSearchCharity = () => {
    return (
      <> {this.props.isCharitySearch ? this.renderSearchCharityTable() : ''} </>
    );
  };

  renderSearchGemini = () => {
    return (
      <> {this.props.isGeminiSearch ? this.renderSearchGeminiTable() : ''} </>
    );
  };

  render() {
    const {
      showGeminiFilter,
      multipleCharities,
      selectedCharity,
      showPendingCharity,
    } = this.state;
    const {
      pendingGrantsLoading,
      pendingAgreements,
      pendingGrants,
      pendingActiveSchedule,
      isLoadingSaved,
    } = this.props;
    let footerAdjustStyles = ['mt-50'];
    if (this.props.searchCharity.length === 0 && !this.props.searchGeminiData) {
      footerAdjustStyles.push('no-margin');
    }

    let charityAddress = '';
    if (selectedCharity && selectedCharity.address) {
      charityAddress = addressFormat(selectedCharity.address);
    }
    return (
      <div>
        {!this.props.isLoadingSaved ? (
          <>
            <GrantGreyBackgroundSection
              className={footerAdjustStyles.join(' ')}
            >
              <ContentProvider
                types={[Types.PAGE_TITLE_DESCRIPTION]}
                pages={['Find a charity']}
              >
                <Row>
                  <FixedWidth>
                    <GrantSectionHeading>
                      <ContentMessage
                        type={[Types.PAGE_TITLE_DESCRIPTION]}
                        page='Find a charity'
                        property='field_page_title'
                        defaultMessage='Find a charity'
                      />
                    </GrantSectionHeading>
                    <GrantSectionSubHeading>
                      <Contents.Consumer>
                        {(props) => {
                          if (
                            props.page_title_description &&
                            props.page_title_description['Find a charity']
                          ) {
                            var PageData = replaceAnchorWithLink(
                              props.page_title_description['Find a charity']
                                .description__value,
                              'link',
                              ''
                            );
                            return PageData.map((data) => {
                              if (typeof data === 'string') {
                                return (
                                  <span
                                    key={data}
                                    dangerouslySetInnerHTML={{ __html: data }}
                                  ></span>
                                );
                              } else {
                                return (
                                  <LinkToSamll id='anrFindacharity'>
                                    {data}
                                  </LinkToSamll>
                                );
                              }
                            });
                          }
                        }}
                      </Contents.Consumer>
                    </GrantSectionSubHeading>
                    <CharitySearch
                      fromPage={this.props.fromPage}
                      isFull={this.props.isFull}
                    />
                  </FixedWidth>
                </Row>
              </ContentProvider>
            </GrantGreyBackgroundSection>
            <ScrollUpSection />
          </>
        ) : (
          <Preloader />
        )}
        <FixedWidth>
          {!showGeminiFilter ? (
            <Row>{this.renderSearchCharity()}</Row>
          ) : (
            <Row>{this.renderSearchGemini()}</Row>
          )}
          {multipleCharities.length ? (
            <MultipleCharityPopup
              show={!!multipleCharities.length}
              charities={multipleCharities}
              secondaryCta={this.onCancelMultipleCharity}
              primaryCta={this.saveSelectedCharity}
            />
          ) : (
            ''
          )}
          {showPendingCharity && (
            <GrantPopup
              popupTitle='Pending grant alert'
              popupDesc='Pending grant(s) for the charity selected already exists.'
              grantName={selectedCharity.name}
              grantAddress={charityAddress}
              grantEin={selectedCharity.ein}
              show={showPendingCharity}
              onCancel={this.onCancelPendingCharity}
              primaryCta={this.makeGrant}
              schedule={pendingActiveSchedule}
              agreements={pendingAgreements}
              grantActivityClick={this.grantActivityClickHandler}
              grantDetailsHandler={this.viewGrants}
              loading={pendingGrantsLoading}
              primaryCtaLabel='Yes, Make A New Grant'
              secondaryCtaLabel='No,take me back'
              renderDesktop={
                <CustomTable
                  dataSource={pendingGrants}
                  columns={pendingCharityColumns(this.viewGrants)}
                  pagination={false}
                />
              }
              renderMobile={
                pendingGrants &&
                pendingGrants.map((data, index) => (
                  <RenderCard
                    key={data.ein}
                    data={data}
                    index={index}
                    type='pending'
                    grantDetailsHandler={this.viewGrants}
                    component='PopupCard'
                  />
                ))
              }
            />
          )}
        </FixedWidth>
        <DrupalPopup
          html={true}
          page={'Grants Overview'}
          show={!this.state.eligible}
          defaultPrimaryLabel={'Ok'}
          defaultSecondaryLabel={'Cancel'}
          defaultTitle={'Warning'}
          keyProperty={'Ineligible'}
          defaultDescription={
            'The charity you selected is not identified as a 501(c)(3) public charity by GuideStar. Vanguard Charitable will need to review the organization before issuing a grant. Click OK to continue with a grant, or CANCEL to select another charity'
          }
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ eligible: true })}
          alertId="overview-ineligible"
        />
        <DrupalPopup
          html={true}
          page={'Grants Overview'}
          show={this.state.partialEligibility}
          defaultPrimaryLabel={'Ok'}
          defaultSecondaryLabel={'Cancel'}
          defaultTitle={'Warning'}
          keyProperty={'Partial Eligible'}
          defaultDescription={
            'The charity you selected is identified as a 501(c)(3), 509(a)(3) supporting organization by GuideStar. You may experience grant processing delays since this type of organization requires additional research. Click OK to continue with a grant, or CANCEL to select another charity'
          }
          primaryCta={this.saveInEligibleCharities}
          secondaryCta={() => this.setState({ partialEligibility: false })}
          alertId="overview-partial-eligible"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...charitySelectStates(state.toJS()),
});

const mapDispatchToProps = (dispatch) => ({
  showGeminiFilter: (data) => dispatch(grantShowGeminiFilter(data)),
  searchGemini: (data) => dispatch(grantSearchGemini(data)),
  selectCharity: (charity, link) =>
    dispatch(selectCharity({ ...charity, charityRefPath: link })),
  removeCharity: (data, successFn) =>
    dispatch(grantRemoveCharity(data, successFn)),
  fetchSavedCharity: (data) => dispatch(grantFetchSavedCharity(data)),
  saveCharity: (data, successFn) =>
    dispatch(grantPostSavedCharity(data, successFn)),
  addCharity: (data, selectedCharity, successFn) =>
    dispatch(addCharity(data, selectedCharity, successFn)),
  postSavedGemini: (data, successFn) =>
    dispatch(grantPostSavedGemini(data, successFn)),
  cancelSaveCharity: (data) => dispatch(cancelSaveCharity(data)),
  fetchPendingGrant: (data) => dispatch(fetchPendingGrant(data)),
  resetSavedCharityLoadingFlag: () => dispatch(resetSavedCharityLoadingFlag()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CharitySelect)
);

CharitySelect.propTypes = {
  activityBlocked: PropTypes.string,
  addCharity: PropTypes.func,
  cancelSaveCharity: PropTypes.func,
  comingSoon: PropTypes.bool,
  fetchPendingGrant: PropTypes.func,
  fetchSavedCharity: PropTypes.func,
  fromPage: PropTypes.string,
  guidestarSearchCount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  isCharitySearch: PropTypes.bool,
  isFull: PropTypes.bool,
  isGeminiSearch: PropTypes.bool,
  isLoadingCharity: PropTypes.bool,
  isLoadingSaved: PropTypes.bool,
  pendingGrantsLoading: PropTypes.bool,
  postSavedGemini: PropTypes.func,
  recentGrants: PropTypes.array,
  removeCharity: PropTypes.func,
  resetSavedCharityLoadingFlag: PropTypes.func,
  saveCharity: PropTypes.func,
  savedCharities: PropTypes.array,
  searchCharity: PropTypes.array,
  searchGemini: PropTypes.func,
  selectCharity: PropTypes.func,
  showGeminiFilter: PropTypes.func,
};
